// extracted by mini-css-extract-plugin
export default {"wrapper":"facilities-module--wrapper--85f25"};